export { OverlayTarget, OverlayDialogBoundary } from './overlay.directives';
export { ModalOverlay } from './overlay.component';
export { Overlay } from './overlay.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/src/overlay/index.js
// module id = 7
// module chunks = 0